// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2jJt4","left":"StickyBox_left__3NPmV","right":"StickyBox_right__1nwvr"};